export function timesheetReducer(state = "" ,{
    type,
    payload
}){   
    switch(type){
        case "NEW_TIMESHEET":            
        case "UPDATE_TIMESHEET":
            let list = Object.assign({}, state);
            list[payload.timesheet_id] = payload
        
            return list
            
        case "GET_TIMESHEETS":
            return payload

        case "DELETE_TIMESHEET":            
            let list2 = Object.assign({}, state);
            delete list2[payload]
            
            return list2
            
        default:
            return state;
    }
    
}